module.exports = __webpack_public_path__ + "static/media/control_cupboard.6f0ba6b0.png";